<template>
  <div class="songs--container">
      <data-container>
        <template #controls>
                <AppDropdown
                    v-model="filter.sort_by"
                    :options="sortItems"
                    :disabled="isLoading"
                    @input="fetchSongs"
                >
                    Sort by
                </AppDropdown>
                <AppDropdown class="theme-filter"
                    v-model="filter.theme_filter"
                    :options="themeItems"
                    :disabled="isLoading"
                    :checkbox="true"
                    :multiple="true"
                    @input="() => {
                        filter.page = 1
                        fetchSongs()
                    }"
                >
                    Theme Filter
                </AppDropdown>

                <div class="right--controls">
                    <AppButton
                        :disabled="isLoading"
                        modifier="small-primary"
                        @click="uploadCSV = true"
                    >
                        Upload CSV
                    </AppButton>
                    <!-- <AppButton
                        :disabled="isLoading"
                        modifier="small-primary"
                        @click="$router.push({ name: 'CreateMusic' })"
                    >
                        Add New Music
                    </AppButton> -->
                    <AppTextField
                        v-model.trim="filter.keyword"
                        placeholder="Type here"
                        icon-right="search"
                        @input="search"
                    />
                </div>
        </template>
        <template #content>
            <AppTable
                :dataset="songList.data"
                :fields="fields"
                :selected="selectedItems"
                :loading="isLoading"
                @select="selectedItems = $event"
                @endOfScroll="message('end of scroll')"
                :total-count="songList.total"
                :current-page="parseInt(filter.page)"
                :items-per-page="parseInt(filter.count)"
                @changePage="changePage"
            >
                <template #theme="{ props }">
                    {{ props.item.theme.length ? props.item.theme[0].name : '--' }}
                </template>
                <template #created_at="{ props }">
                    {{ props.item.created_at | dateFormatter }}
                </template>
                <template #action="{ props }">
                    <div class="actions">
                        <AppButton modifier="icon small-primary">
                            <img src="@/assets/img/ic-edit.svg" class="icon" @click="view(props.item)">
                        </AppButton>
                        <AppButton modifier="icon small-danger" @click="confirmRemove(props.item)">
                            <img src="@/assets/img/ic-trash.svg" class="icon">
                        </AppButton>
                    </div>
                </template>
            </AppTable>

            <AppPopup
                type="success"
                :visible="uploadCSV"
                @close="uploadCSV = false"
            >
                <UploadCSVForm
                    :progress="progress"
                    @upload="file = $event[0]"
                    @confirm="submitCSV"
                    @close="uploadCSV = false" />
            </AppPopup>
            <AppPopup
                type="warning"
                title="Do you wish to remove this Music?"
                message="This Music will removed in the list."
                :visible="showRemoveDialog"
                @close="cancelRemove"
            >
                <AppButton
                    modifier="small-primary"
                    @click="cancelRemove"
                >
                    Cancel
                </AppButton>
                <AppButton
                    modifier="small-warning"
                    @click="removeSong"
                >
                    Proceed
                </AppButton>
            </AppPopup>
        </template>
    </data-container>
  </div>
</template>

<script>
import DataContainer from '@/components/DataContainer'
import AppDropdown from '@/components/AppDropdown'
import AppButton from '@/components/AppButton'
import AppTextField from '@/components/AppTextField'
import AppTable from '@/components/AppTable'
import AppPopup from '@/components/AppPopup'
import UploadCSVForm from '@/components/UploadCSVForm'
import song from '@/store/song/app.js'
import { songFields, sortItems, themeItems } from '@/utils/meta.js'
import { setQueryParams } from '@/utils/helpers.js'
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
	data () {
		return {
			uploadCSV: false,
			showRemoveDialog: false,
			file: null,
			sort: '',
			musicID: null,
			selectedItems: [],
			themeItems: themeItems
		}
	},

	methods: {
		search (val) {
			this.filter.page = 1
			this.filter.keyword = val
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				this.fetchSongs()
			}, 300)
		},

		fetchSongs () {
		    const query = { ...this.filter }
			Object.keys(query).forEach(key => {
				!query[key] && (delete query[key])
			})
			query.theme_filter && (query.theme_filter = query.theme_filter.join('|'))
			this.$router.push({ query })
			const queryStr = setQueryParams(this.filter)
		    this.$store.dispatch('song/fetchSongs', queryStr.toLowerCase())
		},

		confirmRemove ({ id }) {
			this.showRemoveDialog = true
			this.musicID = id
		},

		cancelRemove ({ id }) {
			this.showRemoveDialog = false
			this.musicID = null
		},

		submitCSV () {
			const form = new FormData()
			form.set('file', this.file)
			form.set('document_type', 'csv')
		    this.$store.dispatch('song/uploadCSV', {
				form,
				callback: () => {
					this.fetchSongs()
					this.uploadCSV = false
					this.file = null
				}
			})
		},

		changePage ({ currentPage, itemsPerPage }) {
			this.filter.page = currentPage
			itemsPerPage !== this.filter.count && (this.filter.page = 1)
			this.filter.count = itemsPerPage
			this.fetchSongs()
		},

		removeSong () {
		},

		view ({ id }) {
		}
	},

	computed: {
		...mapGetters('song', [
			'songList',
			'isLoading'
		]),
		...mapFields('song', [
			'filter',
			'progress'
		]),
		fields () { return songFields },
		sortItems () { return sortItems },
		songPageCounter () {
			const { to, from } = this.songList
			return `${from || 0} - ${to || 0}`
		}
	},

	created () {
		const query = { ...this.$route.query }
		if (Object.keys(query).length) {
			Object.keys(query).forEach(key => {
				if (query[key] && key === 'theme_filter') {
					query[key] = query[key].split('|')
				} else {
					!query[key] && (delete query[key])
				}
			})
			this.filter = { ...query }
		}
		this.fetchSongs()
	},

	beforeCreate () {
		if (!this.$store.hasModule('song')) {
			this.$store.registerModule('song', song)
		}
	},
	components: {
		DataContainer,
		AppDropdown,
		AppButton,
		AppTextField,
		AppTable,
		AppPopup,
		UploadCSVForm
	}
}
</script>

<style lang="scss" scoped>
.songs--container {
    padding: 1.5em;
}
.app-dropdown {
    min-width: 120px;
}

.custom-table {
    margin-top: 12px;
}

.theme-filter {
    margin-left: 8px ;
}

.right--controls{
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;

    .app-button--small-primary {
        margin-right: 12px;
    }
}

/deep/ .app-popup {
    width: 30em;
    padding: 16px 0;
}

.app-count-picker {
    margin-right: 5px;
}

.pagination--counter {
    display: flex;
    flex: 1;
    font-size: 1.2em;
}
</style>
